module.exports = __webpack_public_path__ + "img/04-30-168.07f4b020.png";